export default __webpack_public_path__ + "static/media/icon-16.8401603b.svg";